import { Select } from "@mantine/core";
import type { SortField, SortOrder } from "@/api/types";

interface ApartmentSortProps {
  sortBy: SortField;
  sortOrder: SortOrder;
  onChange: (sortBy: SortField, sortOrder: SortOrder) => void;
}

const sortOptions = [
  { value: "first_seen-desc", label: "Newest first" },
  { value: "first_seen-asc", label: "Oldest first" },
  { value: "rent-asc", label: "Lowest rent" },
  { value: "rent-desc", label: "Highest rent" },
];

export function ApartmentSort({ sortBy, sortOrder, onChange }: ApartmentSortProps) {
  const currentValue = `${sortBy}-${sortOrder}`;

  const handleChange = (value: string | null) => {
    if (value) {
      const [newSortBy, newSortOrder] = value.split("-") as [SortField, SortOrder];
      onChange(newSortBy, newSortOrder);
    }
  };

  return (
    <Select
      value={currentValue}
      onChange={handleChange}
      data={sortOptions}
      styles={{
        input: {
          backgroundColor: "#16213e",
          borderColor: "#0f3460",
        },
      }}
    />
  );
}
